"use strict";

/**
 * Отрисовка превью в виде буклета
 */
(function() {
    var self = Fotobook.preview.booklet = {

        /** DOM элемент для превью книги */
        previewSelector: ".editor-preview-booklet",
        editorModeSingle : null,
        widget: {},

        /**
         * Обработчик события при переключения в режим редактирования
         */
        editMode(){
            if (self.validate()) {
                var $preview = $(self.previewSelector),
                    booklet = $preview.children(".booklet").data("booklet");
                self.setPreviousMode();
                if (booklet) {
                    booklet.destroy();
                }
                $preview.find(".preview-wrap").empty().removeAttr("style");
                Fotobook.bottomPanel.carousel.create();

                $('.bottom-carousel-wrapper').find('.empty').each((i, elem) => {
                    $(elem).find('image.booklet-remove').addClass('inline');
                });
                Fotobook.book.drawCurrent();
            }
        },

        /**
         * Перед выходом из предпросмотра устанавливаем режим отображения в редакторе
         */
        setPreviousMode : function () {
            Fotobook.book.single_page_mode = self.editorModeSingle;
        },

        /**
         * Установить противоположный режим поскольку для двухстраничного продукта
         * нет функционала отображения предпросмотра в одностраничном режиме (в редакторе есть)
         */
        setOppositeMode : function () {
            if (self.editorModeSingle) {
                Fotobook.book.single_page_mode = !self.editorModeSingle;
            }
        },

        /**
         * Обработчик события переключения в режим предпросмотра
         */
        previewMode(){
            if (self.validate()) {
                self.editorModeSingle =  Fotobook.book.single_page_mode;
                self.setOppositeMode();
                self.render();
            }
        },

        // срабатывает сильно позже, чем событие в Editor, нужно переделать
        resize(){
            if ($('html').hasClass("preview")) {
                if (self.validate()) {
                    Fotobook.resizeWorkspace($(self.previewSelector));
                }
            }
        },

        next(){
            if (!self.validate()) return;

            var lastPage = parseInt($('.bv-counter').attr('data-max'), 10),
                currentPage = parseInt($('.bv-current').attr('data-current'), 10);

            if (lastPage === currentPage) {
                $(document).triggerHandler(Fotobook.events.PREVIEW_SCROLL, 1);
            } else {
                self.widget.data('booklet').next();
            }
        },

        prev(){
            if (!self.validate()) return;
            var currentPage = parseInt($('.bv-current') .attr('data-current'), 10);

            if(1 === currentPage) {
                var lastPage = parseInt($('.bv-counter').attr('data-max'), 10);
                $(document).triggerHandler(Fotobook.events.PREVIEW_SCROLL, lastPage);
            } else {
                self.widget.data('booklet').prev();
            }
        },

        scroll(event, goToPage){
            var currentPage = parseInt($('.bv-current').attr('data-current'), 10),
                // флаг указывает на то что в данный момент происходит перелистывание старницы в листалке при просмотре
                isTurningPage = $('.preview-wrapper').find('.booklet-navigation').data('isturningpage');
            if (
                !self.validate()
                || isTurningPage
                || goToPage === currentPage
            ) {
                return;
            }

            var $previewWrap = $('.preview-wrap'),
                widget = self.widget.data('booklet'),
                pages,
                direction;

            if (goToPage <= 1) {
                goToPage = 0;
            }

            var currentSpread = parseInt($previewWrap.find('.b-p1').find('.preview-wrap-page').attr('data-spread'), 10);
            direction = (currentSpread - goToPage) < 0 ? 'end' : 'start';

            pages = self._createBookletPagesOnScroll(Math.ceil(goToPage), currentSpread);

            if (direction === 'end') {
                goToPage = pages.length + $previewWrap.find('.b-page').length - 2;
            } else {
                goToPage = 1;
            }

            if (pages && pages.length) {
                widget.fotobookAdd({direction: direction, pages: pages});
            }

            widget.gotopage(goToPage);
        },

        /**
         * создать набор нужных страниц при событии скролинга буклета
         *
         * @param targetSpread int
         * @param currentSpread int
         * @returns Array
         * @private
         */
        _createBookletPagesOnScroll: function (targetSpread, currentSpread) {
            var pages,
                spreadNumbers,
                spreads = Fotobook.book.fillPageChunks(Fotobook.book.getSortedPagesArray(), false),
                notPossibleNumbers = [currentSpread - 1, currentSpread, currentSpread + 1];
            if ((currentSpread - targetSpread) < 0) {
                targetSpread -= 1; // нумерация с нуля
                spreadNumbers = [targetSpread - 1, targetSpread];
            } else {
                spreadNumbers = [targetSpread - 1, targetSpread, targetSpread + 1];
            }

            spreadNumbers = spreadNumbers.filter(function (value) {
                return notPossibleNumbers.indexOf(value) === -1 && typeof spreads[value] !== 'undefined';
            });

            pages = self.getContent(spreads, spreadNumbers);

            return pages;
        },

        /**
         * Валидация условия отображение одностраничного режима просмотра
         * @returns {boolean}
         */
        validate: function () {
            return $(self.previewSelector).length > 0;
        },

        render: function () {
            var $preview = $(self.previewSelector),
                $wrap = $('.preview-wrap'),
                $spine = $(Fotobook.book.pagesList).find('.spine-outer').clone(),
                all_pages = Fotobook.book.getSortedPagesArray(),
                spreads = Fotobook.book.fillPageChunks(all_pages, false),
                spreads_count = spreads.length,
                spread_nums = [],
                current_spread, start, content, width, height,
                displayRegion = Fotobook.displayRegions.getRegion(Fotobook.PageType.PAGE, true),
                previewCurrentPageSelector = $('.bv-current');

            // Ищем текущую страницу
            for (current_spread = 0; current_spread < spreads_count; current_spread++) {
                const chunk = spreads[current_spread];
                const currentPage = Fotobook.store.getters['OnlineEditor/currentPage'];
                const chunkPageNums = [
                    parseInt(chunk[0].getAttribute('data-page_num'), 10),
                    parseInt(chunk[1].getAttribute('data-page_num'), 10),
                ];
                if (chunkPageNums.includes(currentPage)) {
                    break;
                }
            }

            if (current_spread >= spreads_count) {
                current_spread = 0;
            }

            if (current_spread) {
                spread_nums.push(current_spread - 1);
                start = 1;
            } else {
                start = 0;
            }
            spread_nums.push(current_spread);
            if (current_spread < spreads_count - 1) {
                spread_nums.push(current_spread + 1);
            }

            content = self.getContent(spreads, spread_nums).join('');
            $wrap.html(content);

            width = $preview.width();
            height = width * displayRegion.height / displayRegion.width;

            self.widget = $wrap.booklet({
                "height": height,
                "width": width * 2,
                "pageNumbers": false,
                "startingPage": start * 2,
                "pagePadding": 0,
                "prev": ".book-button-preview.prev",
                "next": ".book-button-preview.next",
                "keyboard": true,
                "shadows": true,
                "create": function (event, data) {
                    var current_spread = parseInt(data.pages[0].getAttribute("data-spread"), 10);
                    $preview.append($spine);
                    Fotobook.book.checkBookletButtons(current_spread, spreads_count);
                    Fotobook.book.updateHtmlPageClasses($(data.pages[0]).find(".book-page"));
                    Fotobook.pages.updatePageNumbers();

                    previewCurrentPageSelector.val(current_spread + 1).attr('data-current', current_spread + 1);
                    $('.bv-counter').attr('data-max', spreads_count).text(spreads_count);

                    setTimeout(function () {
                        $(document).trigger("resize");
                    }, 0);
                },
                "start": function (event, data) {
                    const current_page = Fotobook.book.getPageNumFromSpread(data.pages[0]);
                        // current_page = $($(data.pages[1]).find('.book-page')[1]).data('page_num'),
                        // current_page = $('#book-preview').find('.b-p2').find('.right').data('page_num'),
                    const current_spread = parseInt(data.pages[0].getAttribute("data-spread"), 10);

                    Fotobook.store.dispatch('OnlineEditor/setCurrentPage', current_page);

                    Fotobook.book.checkBookletButtons(current_spread, spreads_count);
                },
                "change": function (event, data) {
                    var widget = $(this).data("booklet"),
                        current_spread = parseInt(data.pages[0].getAttribute("data-spread"), 10),
                        calculatedPage = current_spread + 1;
                    Fotobook.book.updateHtmlPageClasses($(data.pages[0]).find(".book-page"));

                    // обновляем уже после анимации
                    Fotobook.pages.updatePageNumbers();

                    $(document).triggerHandler(
                        Fotobook.events.CHANGE_PAGE,
                        Fotobook.store.getters['OnlineEditor/currentPage']
                    );
                    previewCurrentPageSelector.val(calculatedPage).attr('data-current', calculatedPage);

                    var update = {
                        "remove": false,
                        "add_to": false,
                        "pages": false,
                        "new_index": false,
                    };
                    if (data.options.movingForward) {
                        if (data.options.currentIndex > 2) {
                            update.remove = "start";
                        }
                        if ((data.options.currentIndex + 2 >= data.options.pageTotal) && (current_spread + 1 < spreads_count)) {
                            update.pages = self.getContent(spreads, [current_spread + 1]);
                            update.add_to = "end";
                        }
                    } else {
                        if (current_spread < spreads_count - 2) {
                            update.remove = "end";
                        }
                        if (current_spread > 0 && data.options.currentIndex <= 2) {
                            update.pages = self.getContent(spreads, [current_spread - 1]);
                            update.add_to = "start";
                        }
                    }
                    if (update.remove || update.add_to) {
                        widget.fotobookUpdate(update);
                    }

                    // очень нежелательно выполнять частые ресайзы !!!
                    $(document).triggerHandler(Fotobook.events.EDITOR_RESIZE, event);
                }
            });
        },

        /**
         * Отрисовать страницы для предпросмотра фотокниги
         *
         * @param spreads
         * @param spread_nums
         * @returns {Array}
         */
        getContent: function (spreads, spread_nums) {
            var html = [];
            for (var i = 0, l = spread_nums.length; i < l; i++) {
                var spread_num = spread_nums[i];
                if (typeof spreads[spread_num][0] != "string") {
                    var wrapper_height = $(spreads[spread_num]).closest(".pages-wrapper")[0].style.height,
                        spread = [
                            '<div class="pages-wrapper" style="height:', wrapper_height, '">',
                            spreads[spread_num][0].outerSVG,
                            spreads[spread_num][1].outerSVG,
                            '</div>',
                        ].join(""),
                        $spread = $(Fotobook.book.carouselContentToBook(spread)),
                        tmp;

                    Fotobook.book.updatePageWrapperClasses.call($spread[0]);
                    $spread.find(".ajax-tooltip").removeClass(".ajax-tooltip");
                    $spread.find(".booklet-remove").remove();
                    tmp = [
                        '<div class="preview-wrap-page" data-spread="' + spread_num + '">',
                        $spread[0].outerSVG,
                        "</div>"
                    ].join("");
                    spreads[spread_num] = [
                        Fotobook.book.regenerateUniqueIds(tmp),
                        Fotobook.book.regenerateUniqueIds(tmp),
                    ];
                }
                html = html.concat(spreads[spread_num]);
            }

            return html;
        },
    };

    $(document)
        .on(Fotobook.events.PREVIEW_NEXT, self.next)
        .on(Fotobook.events.PREVIEW_PREV, self.prev)
        .on(Fotobook.events.PREVIEW_SCROLL, self.scroll)
        .on(Fotobook.events.SWITCH_EDIT_MODE, self.editMode)
        .on(Fotobook.events.SWITCH_PREVIEW_MODE, self.previewMode)
        .on(Fotobook.events.EDITOR_RESIZE, self.resize)
        .on(Fotobook.events.PRODUCT_CONTENT_CHANGED, self.previewMode);
})();
